/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Stat_HitInputs */

const bn_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আঘাত`)
};

const de_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlag`)
};

const el_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιτυχία`)
};

const en_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit`)
};

const es_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golpear`)
};

const fr_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réussites`)
};

const hi_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार`)
};

const hu_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találat`)
};

const id_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memukul`)
};

const it_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colpo`)
};

const ja_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打つ`)
};

const ko_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`때리다`)
};

const nl_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit`)
};

const pl_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uderzyć`)
};

const pt_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bater`)
};

const ru_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ударять`)
};

const sv_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit`)
};

const tr_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vurmak`)
};

const uk_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`удар`)
};

const vi_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh`)
};

const zh_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打`)
};

const zh_hant_game_stat_hit = /** @type {(inputs: Game_Stat_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打`)
};

/**
* | output |
* | --- |
* | "Hit" |
*
* @param {Game_Stat_HitInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_stat_hit = /** @type {((inputs?: Game_Stat_HitInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Stat_HitInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_stat_hit(inputs)
	if (locale === "de") return de_game_stat_hit(inputs)
	if (locale === "el") return el_game_stat_hit(inputs)
	if (locale === "en") return en_game_stat_hit(inputs)
	if (locale === "es") return es_game_stat_hit(inputs)
	if (locale === "fr") return fr_game_stat_hit(inputs)
	if (locale === "hi") return hi_game_stat_hit(inputs)
	if (locale === "hu") return hu_game_stat_hit(inputs)
	if (locale === "id") return id_game_stat_hit(inputs)
	if (locale === "it") return it_game_stat_hit(inputs)
	if (locale === "ja") return ja_game_stat_hit(inputs)
	if (locale === "ko") return ko_game_stat_hit(inputs)
	if (locale === "nl") return nl_game_stat_hit(inputs)
	if (locale === "pl") return pl_game_stat_hit(inputs)
	if (locale === "pt") return pt_game_stat_hit(inputs)
	if (locale === "ru") return ru_game_stat_hit(inputs)
	if (locale === "sv") return sv_game_stat_hit(inputs)
	if (locale === "tr") return tr_game_stat_hit(inputs)
	if (locale === "uk") return uk_game_stat_hit(inputs)
	if (locale === "vi") return vi_game_stat_hit(inputs)
	if (locale === "zh") return zh_game_stat_hit(inputs)
	return zh_hant_game_stat_hit(inputs)
});